import type { IGetBalanceAndDateResponse } from '@/app-package';
import axios from 'axios';

export const getBalanceAndDate = async (orgId: string, userId?: string) => {
  const { data: balanceAndDate } = await axios.get<IGetBalanceAndDateResponse>(
    `/billing/balance_and_date`,
    { params: { orgId, userId } },
  );

  return balanceAndDate;
};
